/**
 * get the key of nested object in a certain depth (recursively)
 *
 * @param object object with nested objects
 * @param depth nested object depth
 */
export const getObjectKey = (object, depth) => {
  if (!object) return null
  const onlyKeyInObject = Object.keys(object)[0]
  if (depth <= 0) {
    return onlyKeyInObject
  } else {
    return getObjectKey(object[onlyKeyInObject], depth - 1)
  }
}

/**
 * makes the first letter of a string capital
 *
 * @param word
 */
export const capitalize = (word) => {
  if (!word) return word
  return word.charAt(0).toUpperCase() + word.slice(1)
}

/**
 * replace underscore by space and capitalize each word
 *
 * @param str
 */
export const humanize = (str) => {
  let i
  const frags = str.split('_')
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags.join(' ')
}

export const convertToMachineKey = (str) => {
  if (!str) return ''
  return str.replace(/[,.\- ]/g, '_').toLowerCase()
}
/**
 * sort array of object by field
 *
 * @param a first element
 * @param b second element
 * @param field the field to be used for sorting
 */
export const sortBy = (a, b, field) => {
  if (!a || !b) return 0
  if (a === b) return 0
  if (a[field] < b[field]) {
    return -1
  } else {
    return 1
  }
}

export const accessRoles = {
  ADMIN: 'Admin',
  COORDINATOR: 'Coordinator',
  FORM_BUILDER: 'Form Builder',
  VIEW_ONLY: 'View Only'
}

export const calculateMaterialsSubTotal = (materials) => {
  let total = 0
  for (const item of materials) {
    if (item?.total_price) {
      total += +item?.total_price // transform string to number
    }
  }
  return total
}

export const calculateLineItemsSubTotal = (lineItems) => {
  let total = 0
  for (const item of lineItems) {
    if (item?.total) {
      total += +item?.total // transform string to number
    }
  }
  return total
}
